import type { Transition, Variants } from 'framer-motion'

/**
 * How a Mini element enters and leaves: a fade with a short slide from the side the Mini is
 * docked to, so on either edge of the screen it grows away from that edge. Shared by the Ask label,
 * the meeting controls, the quick actions and the menu, so both sides animate alike.
 */
export const MINI_REVEAL_TRANSITION: Transition = { duration: 0.15, ease: 'easeOut' }

const FROM_LEFT: Variants = { hidden: { opacity: 0, x: -4 }, visible: { opacity: 1, x: 0 } }
const FROM_RIGHT: Variants = { hidden: { opacity: 0, x: 4 }, visible: { opacity: 1, x: 0 } }

export const miniRevealVariants = (isAnchoredLeft: boolean): Variants => (isAnchoredLeft ? FROM_LEFT : FROM_RIGHT)

/**
 * `popLayout` lifts an exiting element out of the flow at its left edge by default; a Mini docked
 * right grows and shrinks from its right edge, so it pins exits there instead.
 */
export const miniPresenceAnchor = (isAnchoredLeft: boolean): 'left' | 'right' => (isAnchoredLeft ? 'left' : 'right')
